// The codes redeemed on this phone (see lib/licence), unchecked: they're checked again on every
// start by the keeper in stores/slices/licenceSlice. In localStorage rather than Dexie because the
// keeper reads them as it's made, synchronously, as Blackbox's does.
const KEY = 'choreschamp.licences';

export function loadLicenceCodes(): string[] {
  try {
    const value: unknown = JSON.parse(localStorage.getItem(KEY) ?? '[]');
    return Array.isArray(value) ? value.filter((c): c is string => typeof c === 'string') : [];
  } catch {
    return [];
  }
}

export function saveLicenceCodes(codes: string[]): void {
  localStorage.setItem(KEY, JSON.stringify(codes));
}
